// extracted by mini-css-extract-plugin
export default {"flexData":"TableUserManagement_flexData__yIigH","leftData":"TableUserManagement_leftData__22Lrh","gridData":"TableUserManagement_gridData__VeHaT"};